import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class FormatSearchCriteriasService {
    constructor() {}

    formatFilters(filters) {
        const formatedFilters = {}
        for (const elem in filters) {
            if (filters[elem]) {
                if (Array.isArray(filters[elem]) && !filters[elem].length) {
                    continue
                }
                if (typeof filters[elem] === 'boolean' && filters[elem]) {
                    formatedFilters[elem] = filters[elem]
                    continue
                }
                if (typeof filters[elem] === 'string' && filters[elem]) {
                    formatedFilters[elem] = String(filters[elem])
                    continue
                }
                formatedFilters[elem] = isNaN(Number(filters[elem]))
                    ? filters[elem]
                    : Number(filters[elem])
            }
        }

        return formatedFilters
    }
       public  convertDatesToStrings(obj: any): any {
        if (obj instanceof Date) {
            return this.formatDateOnly(obj);
        }

        if (Array.isArray(obj)) {
            return obj.map((item) => this.convertDatesToStrings(item));
        }

        if (obj !== null && typeof obj === 'object') {
            const newObj: any = {};
            for (const key in obj) {
                newObj[key] = this.convertDatesToStrings(obj[key]);
            }
            return newObj;
        }

        return obj;
    }

    private formatDateOnly(value: Date): string {
        const year = value.getFullYear();
        const month = (value.getMonth() + 1).toString().padStart(2, '0');
        const day = value.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
